// client/src/components/StreamPlayer.jsx
import React from "react";
import MuxPlayer from "@mux/mux-player-react";
import "@mux/mux-player/themes/classic"; // no .css extension

export default function StreamPlayer({ playbackId, isLive = false, poster = "" }) {
  if (!playbackId) {
    return (
      <div className="w-full h-full flex items-center justify-center text-slate-400 bg-black/60">
        No playback ID available
      </div>
    );
  }

  const computedPoster = poster || `https://image.mux.com/${playbackId}/thumbnail.png?time=1`;

  return (
    <MuxPlayer
      key={`${playbackId}-${isLive ? "live" : "vod"}`}   // force clean remount on switch
      playbackId={playbackId}
      streamType={isLive ? "live" : "on-demand"}
      controls
      autoPlay={false}
      poster={computedPoster}
      style={{ width: "100%", height: "100%" }}
    />
  );
}
